import axios from "axios";
import qs from "qs";
import {api} from "@/plugins/util";

/**
 * 查询授权书列表
 */
export function getPowerOfAttorneyList(current) {
    return axios.get(api + "/powerOfAttorne/getPowerOfAttorneyList", {
        params: {
            current
        }
    })
}

/**
 * 主键查询
 */
export function selectPrimaryKeyById(id) {
    return axios.get(api + "/powerOfAttorne/selectPrimaryKeyById", {
        params: {
            id
        }
    })
}

/**
 * 添加授权书
 */
export function addPowerOfAttorney(data) {
    return axios.post(api + "/powerOfAttorne/addPowerOfAttorney", data)
}

/**
 * 修改授权书
 */
export function updatePowerOfAttorney(data) {
    return axios.put(api + "/powerOfAttorne/updatePowerOfAttorney", data)
}

/**
 * 删除授权书
 */
export function deletePowerOfAttorney(id) {
    return axios.delete(api + "/powerOfAttorne/deletePowerOfAttorney", {
        params: {
            id
        }
    })
}

/**
 * 启用或禁用授权书
 * @param id 主键
 */
export function enableOrDisablePowerOfAttorney(id) {
    return axios.get(api + "/powerOfAttorne/enableOrDisablePowerOfAttorney", {
        params: {
            id,
        }
    })
}

/**
 * 启用或禁用授权书
 * @param id 主键
 */
export function getEnablePowerOfAttorney() {
    return axios.get(api + "/powerOfAttorne/getEnablePowerOfAttorney", {})
}